import {
  GET_PETITION_UUID_REQUEST,
  GET_PETITION_UUID_SUCCESS,
  GET_PETITION_UUID_FAILURE,
  GET_PETITION_IMAGES_REQUEST,
  GET_PETITION_IMAGES_SUCCESS,
  GET_PETITION_IMAGES_FAILURE,
  RESET_VIEWER,
} from './actionTypes';

const initialState = {
  loading: false,
  error: '',
  petitionImages: null,
};

const viewPetitionImagesReducer = (state = initialState, action) => {
  const { type, error, petitionImages } = action;
  switch (type) {
    case GET_PETITION_UUID_REQUEST:
      return { ...state, loading: true, error: '' };
    case GET_PETITION_UUID_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case GET_PETITION_UUID_FAILURE:
      return { ...state, loading: false, error };

    case GET_PETITION_IMAGES_REQUEST:
      return { ...state, petitionImages: null, error: '' };
    case GET_PETITION_IMAGES_SUCCESS:
      return { ...state, petitionImages };
    case GET_PETITION_IMAGES_FAILURE:
      return { ...state, error };
    case RESET_VIEWER:
      return initialState;
    default:
      return state;
  }
};

export default viewPetitionImagesReducer;
